import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <div className=" flex h-screen w-screen flex-col items-center justify-center bg-[#5570F1]">
      <div className=" relative flex w-[550px] flex-col gap-4 rounded-lg bg-[#ffffff] p-10 font-poppins text-black shadow-lg">
        <h1>404 Error - Page is not found</h1>
        <h2>The requested agent isn't available. Please try again</h2>
      </div>
    </div>
  );
};
export default NotFoundPage;
